export const prepExchangeEngineUrl = (envType) => {
  let exchangeEngineUrl = process.env.REACT_APP_EXCHANGE;
  if (envType === 'ALPHA') {
    exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_ALPHA;
  } else if (envType === 'BETA') {
    exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_BETA;
  } else if (envType === 'PREVIEW') {
    exchangeEngineUrl = process.env.REACT_APP_EXCHANGE_PREVIEW;
  }
  return exchangeEngineUrl;
};

export const prepExchangeSurfaceUrl = (seoName, envType) => {
  const exchangeSurfaceUrl = process.env.REACT_APP_EXCHANGE_SURFACE;
  let url = '';
  if (envType === 'ALPHA') {
    url = `${seoName}.uat.${exchangeSurfaceUrl}`;
  } else if (envType === 'BETA') {
    url = `${seoName}.sandbox.${exchangeSurfaceUrl}`;
  } else if (envType === 'PRODUCTION') {
    url = `${seoName}.${exchangeSurfaceUrl}`;
  } else if (envType === 'PREVIEW') {
    url = `${seoName}.preview.${exchangeSurfaceUrl}`;
  }
  return url;
};

export const getRedirectUrl = () => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    redirectUrl = `http://${domainName}:9075/`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
    domainName = domainName.replace('builder.webkonnect.xyz', 'builderc.webkonnect.xyz');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};
